
import { PredefinedMaster } from "./PredefinedMaster.model";
import { User } from "./User.model";


export class UserOtherDetails{
    public userOtherDetailsId:number;
    public user:User;
    public userId:number;
    public entityName:string;
    public field1:string;
    public field2:string;
    public field3:string;
    public specialization:PredefinedMaster;
    public specializationId:number;
    public isDelete:string;
}